<div matDialogTitle>Skapa nytt projekt</div>
<mat-dialog-content>
  <div class="form">
    <mat-form-field>
      <mat-label>Projektnamn</mat-label>
      <input [formField]="form.projectName" matInput type="text">
    </mat-form-field>
    <mat-form-field>
      <mat-label>Samtycke</mat-label>
      <mat-select [formField]="form.consentId">
        @for (consent of consents(); track $index) {
          <mat-option [value]="consent.id">{{ consent.name }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <div>
    <button [matDialogClose]="null" matButton="outlined"><mat-icon>cancel</mat-icon>Avbryt</button>
    <button [disabled]="form().invalid()" (click)="saveProject()" matButton="filled"><mat-icon>save</mat-icon>Spara</button>
  </div>
</mat-dialog-actions>